import { Link, useLocation } from "react-router-dom";
import { FiHome, FiSearch, FiUser, FiBell } from "react-icons/fi";
import { MdGarage } from "react-icons/md";

function BottomNav({ username }) {
  const location = useLocation();

  const navItems = [
    {
      label: "Home",
      icon: <FiHome />,
      path: "/",
    },
    {
      label: "Discover",
      icon: <FiSearch />,
      path: "/discover",
    },
    {
      label: "Garage",
      icon: <MdGarage />,
      path: "/garage",
      featured: true,
    },
    {
      label: "Notifications",
      icon: <FiBell />,
      path: "/notifications",
    },
    {
      label: "Profile",
      icon: <FiUser />,
      path: username ? `/user/${username}` : "/account",
    },
  ];

  const isActive = (item) => {
    if (item.path === "/") {
      return location.pathname === "/";
    }

    if (item.label === "Profile") {
      return location.pathname.startsWith("/user/");
    }

    return location.pathname.startsWith(item.path);
  };

  return (
    <div style={navShellStyle}>
      <div style={bottomNavStyle}>
        <div style={garageNotchStyle} />

        {navItems.map((item) => {
          const active = isActive(item);

          return (
            <Link
              key={item.label}
              to={item.path}
              style={{
                ...navItemStyle,
                ...(item.featured ? featuredNavItemStyle : {}),
                color: active ? "#ffffff" : "#aaa",
              }}
            >
              <span
                style={{
                  ...iconWrapStyle,
                  ...(item.featured ? featuredIconWrapStyle : {}),
                  ...(active ? activeIconWrapStyle : {}),
                  ...(item.featured && active ? activeGarageIconStyle : {}),
                }}
              >
                {item.icon}
              </span>

              <span
                style={{
                  ...labelStyle,
                  ...(item.featured ? featuredLabelStyle : {}),
                }}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

const navShellStyle = {
  position: "fixed",
  left: 0,
  right: 0,
  bottom: "calc(12px + env(safe-area-inset-bottom))",
  display: "flex",
  justifyContent: "center",
  zIndex: 9999,
  pointerEvents: "none",
};

const bottomNavStyle = {
  position: "relative",
  width: "calc(100% - 32px)",
  maxWidth: "430px",
  height: "76px",
  background: "rgba(10, 10, 10, 0.92)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "999px",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  boxShadow: "0 12px 35px rgba(0,0,0,0.5)",
  pointerEvents: "auto",
  overflow: "visible",
};

const garageNotchStyle = {
  position: "absolute",
  top: "-20px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "96px",
  height: "48px",
  background: "rgba(10, 10, 10, 0.92)",
  borderTop: "1px solid rgba(255,255,255,0.08)",
  borderLeft: "1px solid rgba(255,255,255,0.08)",
  borderRight: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "999px 999px 18px 18px",
  zIndex: 0,
  boxShadow: "0 -8px 24px rgba(0,0,0,0.25)",
};

const navItemStyle = {
  position: "relative",
  zIndex: 2,
  textDecoration: "none",
  background: "transparent",
  border: "none",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "5px",
  fontSize: "10px",
  fontWeight: 700,
  minWidth: "64px",
  cursor: "pointer",
  fontFamily: "inherit",
};

const featuredNavItemStyle = {
  transform: "translateY(-14px)",
};

const iconWrapStyle = {
  fontSize: "22px",
  width: "36px",
  height: "36px",
  borderRadius: "999px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.2s ease",
};

const featuredIconWrapStyle = {
fontSize: "30px",
width: "56px",
height: "56px",
  background: "#181818",
  border: "1px solid rgba(255,255,255,0.1)",
  boxShadow: "0 10px 24px rgba(0,0,0,0.45)",
  transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
};

const activeIconWrapStyle = {
  background: "#e10600",
  color: "#fff",
  boxShadow: "0 8px 18px rgba(225, 6, 0, 0.35)",
};

const activeGarageIconStyle = {
  boxShadow: "0 10px 28px rgba(225, 6, 0, 0.45)",
  transform: "scale(1.05)",
};

const labelStyle = {
  fontSize: "10px",
  lineHeight: "1",
  maxWidth: "72px",
  textAlign: "center",
  whiteSpace: "nowrap",
};

const featuredLabelStyle = {
  marginTop: "-1px",
};

export default BottomNav;